import { User } from '../user/user.types';

// Define an interface for opening a register (cash box)
export interface OpenRegister {
  cashBoxId: number; // Cash box ID
  employeeId: number; // Employee ID
  userId: number; // User ID
  initialValue: number; // Initial cash value in the register
}

// Define an interface for closing a register (cash box)
export interface CloseRegister {
  closeId: number; // Closing operation ID
  userId?: number; // User ID (optional - user performing the closure)
  closingUserId: number; // User ID of the one who closed the register
  isManager: boolean; // Indicates if the user is a manager (true or false)
  closingBalance: number; // Final cash balance in the register
}

// Define an interface for search parameters when querying closed registers
export interface SearchClosingsParams {
  cashBox?: string | number; // Cash box identifier (optional)
  date?: string; // Query date in "YYYY-MM-DD" format (optional)
  managerId?: number; // Manager's ID (optional)
  employeeId?: number; // Employee ID (optional)
  userId?: number; // User ID (optional)
  username?: string; // Username (optional)
}

// Define an interface for bank details in the system
export interface Register {
  bankId: number; // Bank ID
  name: string; // Bank name
  accountNumber: string; // Account number
  nib: string; // NIB (Bank Identification Number)
  iban: string; // IBAN (International Bank Account Number)
  balance: number; // Account balance
  employeeId: number; // Associated employee ID
  accountingPlanId: number; // Accounting plan ID
  bankTypeId?: number | null; // Bank type ID (optional, nullable)
  status: string; // Current account status
  visibleOnInvoice: boolean; // Visibility of the account on invoices
  associatedBankId?: number | null; // Associated bank's ID (optional, nullable)
  printerDetails?: {
    printerName: string | null; // Printer name (optional, nullable)
    ipAddress: string | null; // Printer IP address (optional, nullable)
    port: string | null; // Printer port (optional, nullable)
  };
}

// Define an interface for register closing entries
export interface ClosingEntry {
  entryId: number; // Unique Closing Entry ID
  startDate: string; // Start date of the transaction/activity
  endDate: string; // End date of the transaction/activity
  user: User; // User who initiated the transaction/activity
  bankId: number; // ID of the associated bank
  bankDetails: Register; // Bank details (reference to the BankDetails interface)
  closingUser: User; // User who closed the activity/transaction
}

// Define structure for the result of search operations for closed registers
export interface SearchClosingsResult {
  data: {
    closingEntries: ClosingEntry[];
  };
}

// Define statuses for a register in the system
export enum RegisterStatus {
  NONE_OPEN = 0, // No registers are currently open
  USER_HAS_ACCESS = 1, // The current user has access to the open register
  OPEN_BY_OTHER = 2, // A register is open but accessed by another user
  // USER_HAS_REGISTER = 3, // The current user already has their own open register
  HAS_OPEN = 3
}
